import MetricAPI from "../../../api/metric"
import { useResponseHandle } from "../../hooks"

const metricAPI = new MetricAPI()

export const fetchGroupsHandler = async (params: any) => {
  const { token, dispatch, navigate, loading } = params

  loading(true)
  const response = await metricAPI.getMetricGroupsBoarded(token)

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let tempGroupArr: any = []

      result?.data?.forEach((group: any) => {
        tempGroupArr.push({ ...group, label: group?.group_name })
      })

      dispatch([...tempGroupArr])
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchRegionsHandler = async (params: any) => {
  const { token, dispatch, navigate, group } = params
  const { loading } = params

  loading(true)
  const response = await metricAPI.getMetricRegionsByGroups(token, [
    group?.group_sk,
  ])

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let tempRegionArr: any = [{ label: "All", name: "all" }]

      result?.data?.regions?.forEach((region: any) => {
        tempRegionArr.push({ ...region, label: region, name: region })
      })

      dispatch([...tempRegionArr])
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchOfficesHandler = async (params: any) => {
  const { token, dispatch, navigate } = params
  const { group, region } = params
  const { loading } = params

  loading(true)
  const response = await metricAPI.getMetricPracticesByRegions(
    token,
    [group?.group_sk],
    [region.name],
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let tempOfficeArr: any = [
        { practice_sk: "all", label: "All", name: "all" },
      ]

      result?.data?.forEach((office: any) => {
        tempOfficeArr.push({
          ...office,
          practice_sk: office?.practice_sk,
          label: office?.name,
          name: office?.name,
        })
      })

      dispatch([...tempOfficeArr])
      loading(false)
    }
  } else {
    loading(false)
    navigate("/auth")
  }
}
